<template>
    <main class="main-content main-content-green">
        <div class="container-fluid container-sports --green">
            <div class="row">
                <div class="col-12">
                    <p class="sports-title"><strong v-if="time">{{time.initials}}</strong></p>
                </div>
            </div>
        </div>

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <div id='div-gpt-ad-1603501550614-0'></div>
                </div>
            </div>
        </div>

        <div class="container container_latest-new" v-if="noticias">
            <div class="row">
                <div class="col-12 col-lg-8">
                    <div class="row container_latest-new" v-for="n in noticias" :key="n.id">
                        <div class="col-12">
                            <router-link 
                                class="noticies-item noticies-item--nofloat noticies-item--img-small"
                                :to="n.url">
                                <div class="noticies-item--image" v-if="n.image">
                                    <img :src="utils.image(n.image, width=160, height=104)" alt="" />
                                </div>
                                <div class="noticies-item--info">
                                    <p class="noticies__label"><strong>{{utils.date(n.meta.first_published_at)}} - {{n.editorial.title}}</strong></p>
                                    <p class="noticies__title noticies__title--green"><strong>{{n.title}}</strong></p>
                                    <p class="noticies__text">{{n.subtitle}}</p>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    

                    <div class="row">
                        <div class="col-12">
                            <Pagination :count="count" :limit="limit" />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div id='div-gpt-ad-1603502104885-0'></div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import api from '@/api'
import utils from '@/utils'

import Pagination from '@/components/Pagination'

export default {
    name: 'Time',
    components:{Pagination},
    head:{
        title: function(){
            return {
                inner: this.title
            }
        }
    },
    data(){
        return {
            title: '',
            time: null,
            noticias: null,
            utils: utils,
            count: 0,
            limit: 10,
        }
    },
    computed: {
        current_page: function() {
            if ('page' in this.$route.query) {
                return this.$route.query.page
            }
            return 1
        }
    },
    watch:{
        time: function (){
            this.getNoticias()
        }
    },
    methods:{
        async getTime () {
            const response = await api.get(`teams/${this.$route.params.slug}`)

            if (response.ok) {
                this.time = response.data
                this.title = this.time.name
                this.$emit('updateHead')
            }
        },
        async getNoticias() {
            let offset = (this.current_page-1)*this.limit
            const response = await api.get('pages/', {
                type: 'news.NewsPage',
                teams: this.time.id,
                fields: 'subtitle,editorial,image,url',
                order: '-first_published_at',
                limit: this.limit,
                offset: offset
            })

            if (response.ok) {
                this.noticias = response.data.items
                this.count = response.data.meta.total_count
            }
        }
    },
    mounted() {
        this.getTime()

        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.defineSlot('/1513505/v1_gweb_arroba_lateral', [300, 250], 'div-gpt-ad-1603502104885-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices();
            googletag.display('div-gpt-ad-1603501550614-0');
            googletag.display('div-gpt-ad-1603502104885-0');
        })
    }
}
</script>